window.fireOnVisible(document.querySelector('.wt-Reviews'), async () => {
    await import('./assets/css/reviews.scss');

    if (window.TCMS.product === 'mietwagen') {
        await import('./assets/css/reviews-mietwagen.scss');
    }
});
